import React from 'react';
import StandCard from './StandCard';
import ProductsCard from './ProductsCard';

class Stand extends React.Component {
  render()  {
    const {standKey} = this.props.match.params;
    return (
      <div>
        <StandCard standKey={standKey} />
        <ProductsCard standKey={standKey} />
      </div>
    );
  }
}

export default Stand;



// WEBPACK FOOTER //
// ./src/Stand/Stand.js